import { Axios } from 'utils'
import { ListResponseType } from 'services/types'
import { TBakersInsight, TUpdateInsight } from 'types/models/BakersInsights'

export const useBakersInsightService = () => {
  const getBakersInsightListByDeliveryId = async (deliveryId: number) => {
    try {
      const response = await Axios.get<ListResponseType<TBakersInsight>>(
        `/baker/insights/${deliveryId}/list`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateInsightByGuid = async (
    guid: string,
    insightInstance: TUpdateInsight
  ) => {
    try {
      const response = await Axios.put<ListResponseType<TBakersInsight>>(
        `/baker/insights/${guid}/update`,
        insightInstance
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getBakersInsightListByDeliveryId,
    updateInsightByGuid,
  }
}
